import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pay-info-confirm" }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = {
  style: {"padding-bottom":"0","padding-right":"0"},
  class: "xrk-dialog__footer"
}

import { ref } from 'vue';

import {
  BaseButton,
  BaseTable,
  BaseDescriptions,
  BaseDescriptionsItem,
  createDialog,
  BaseInput,
  XrkMessage
} from 'xrk-components';
import { formatter } from '@/utils';
import { maskPhone } from '@/utils/formatter';
import emitter from '../utils/event-bus';

import { submitList, paySubmit } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  orderTimeCol,
  orderTypeCol,
  projectNameCol,
  customerNameCol,
  payTypeCol,
  payPassagewayCol,
  csoPriceSumCol
} from '../fields/columns';
import { getVerifyCodeApi, operatorInfo } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-info-confirm',
  props: {
    done: { default: () => ({}) },
    payInfo: { default: null }
  },
  setup(__props: any) {

const props = __props;
const tipsInfoData = ref({
  projectServiceOrderNum: 0, //项目服务费订单数量
  terminalSettlementAmount: 0, //终端结算金额（分）
  comprehensiveServiceFeeOrderNum: 0, //关联综合服务费订单数量
  comprehensiveServiceFeeAmount: 0, //综合服务费订单金额(分)
  totalAmount: 0 //共计金额
});
const verifyCode = ref('');
const countdown = ref<number>(0);
const codeMsg = ref('获取验证码');
const phoneNumber = ref('');

const getPhoneNumber = async () => {
  const { data } = await operatorInfo({ t: Date.now() });
  phoneNumber.value = data.phone;
};
getPhoneNumber();

const getVerifyCode = async () => {
  if (countdown.value === 0) {
    await getVerifyCodeApi({
      phone: phoneNumber.value
    });
    countdown.value = 60;

    const intervalId = setInterval(() => {
      if (countdown.value === 1) codeMsg.value = '重新获取验证码';

      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
  }
};
const onPay = async () => {
  const isLine = props.payInfo.every(item => item.payType === 1);
  if (isLine) {
    createDialog({
      title: '支付身份校验',
      showClose: true,
      confirmBtnConfig: {
        content: '确认'
      },
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>验证码将发送至您的手机：{maskPhone(phoneNumber.value)}</span>
            <div style="display: flex;margin-top: 20px">
              <BaseInput
                inputTextReplace
                inputTexts={['数字']}
                v-model={verifyCode.value}
                maxlength={6}
                placeholder="请输入验证码"
              />
              <BaseButton
                click={() => {
                  getVerifyCode();
                }}
                disabled={countdown.value > 0}
                type="primary"
                style="margin-left: 5px;width: 100px"
              >
                {countdown.value || codeMsg.value}
              </BaseButton>
            </div>
          </div>
        );
      },
      async beforeConfirm(done) {
        if (!verifyCode.value) {
          XrkMessage.error('请输入验证码');
          return Promise.reject();
        }
        try {
          await paySubmit({
            verifyCode: verifyCode.value,
            idList: props.payInfo.map(item => item.id)
          });
          XrkMessage.success('支付成功');
          emitter.emit('refresh-order-tabel', { data: true });
          props.done();
          done();
        } catch (err) {
          return Promise.reject();
        }
      }
    });
  } else {
    //线下支付不需要验证码
    await paySubmit({
      idList: props.payInfo.map(item => item.id)
    });
    XrkMessage.success('支付成功');
    emitter.emit('refresh-order-tabel', { data: true });
    props.done();
  }
};

const tableColumns = [
  indexCol,
  orderNoCol,
  orderTimeCol,
  orderTypeCol,
  projectNameCol,
  customerNameCol,
  payTypeCol,
  payPassagewayCol,
  csoPriceSumCol
];
const dataList = ref([]);
const getListAjax = async () => {
  const reqData = {
    supplierOrderIdList: props.payInfo.map(item => item.id)
  };
  const { data } = await submitList(reqData);

  tipsInfoData.value = {
    projectServiceOrderNum: data.projectServiceOrderNum, //项目服务费订单数量
    terminalSettlementAmount: data.terminalSettlementAmount, //终端结算金额（分）
    comprehensiveServiceFeeOrderNum: data.comprehensiveServiceFeeOrderNum, //关联综合服务费订单数量
    comprehensiveServiceFeeAmount: data.comprehensiveServiceFeeAmount, //综合服务费订单金额(分)
    totalAmount: data.totalAmount //共计金额
  };
  dataList.value = data.dataList;
};
getListAjax();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTable), {
      data: dataList.value,
      columns: tableColumns
    }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseDescriptions), {
        border: true,
        column: 5
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseDescriptionsItem), { label: "选中项目服务费订单数量" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tipsInfoData.value.projectServiceOrderNum) + "个 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseDescriptionsItem), { label: "终端结算金额" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.terminalSettlementAmount, '元')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseDescriptionsItem), { label: "关联综合服务费订单数量" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tipsInfoData.value.comprehensiveServiceFeeOrderNum) + "个 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseDescriptionsItem), { label: "综合服务费订单金额" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.comprehensiveServiceFeeAmount, '元')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseDescriptionsItem), { label: "共计" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.totalAmount, '元')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: props.done
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        disabled: !_ctx.payInfo.length,
        type: "primary",
        onClick: onPay
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 发起支付 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})